import { routes } from '~/components/app/appMainRoutes';
import { enrichmentRoutes } from '~/components/HubspotEnrichment/constants';
import { settingsRoutes } from '~/components/settings/settingsRoutes';

import { useHomeIntegrations } from '../hooks/useHomeIntegrations';
import { OnboardingChecklist } from './OnboardingChecklist';
import { OnboardingItem, OnboardingItemDivider } from './OnboardingItem';

export const ListEnrichment = () => {
  const {
    hasCompanyEnrichment,
    hasContactEnrichment,
    hasEnrichmentMappings,
    isHubSpotConnected,
    loadingAccount,
  } = useHomeIntegrations();

  const isLoading = loadingAccount;

  return (
    <OnboardingChecklist title="Get started with Enrichment">
      <OnboardingItem
        isComplete={isHubSpotConnected}
        isLoading={isLoading}
        number={1}
        title="Connect to HubSpot"
        to={settingsRoutes.hubSpotIntegration}
      />
      <OnboardingItemDivider />
      <OnboardingItem
        isComplete={hasEnrichmentMappings}
        isDisabled={!isHubSpotConnected}
        isLoading={isLoading}
        number={2}
        title="Set up enrichment mappings"
        to={enrichmentRoutes.mappingCompanies}
      />
      <OnboardingItemDivider />
      <OnboardingItem
        isComplete={hasCompanyEnrichment}
        isDisabled={!isHubSpotConnected}
        isLoading={isLoading}
        number={3}
        title="Enable company enrichment"
        to={routes.enrichment}
      />
      <OnboardingItemDivider />
      <OnboardingItem
        isComplete={hasContactEnrichment}
        isDisabled={!isHubSpotConnected}
        isLoading={isLoading}
        number={4}
        title="Enable contact enrichment"
        to={routes.enrichment}
      />
    </OnboardingChecklist>
  );
};
